mutation pauseChannelForLead($input: PauseChannelForLeadInput!) {
  pauseChannelForLead(input: $input)
}
